// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rating-gauge {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  font-size: 14px;
}

.gauge-wrap {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 132px;
}

.gauge-svg {
  height: 65px;
  overflow: visible;
}

.gauge-track {
  fill: none;
  stroke: #e6e6e6;
  stroke-width: 10;
  stroke-linecap: round;
}

.gauge-sweep {
  fill: none;
  stroke: url(#gaugeGradient);
  stroke-width: 10;
  stroke-linecap: round;
}

.gauge-tick {
  stroke: #d0d0d0;
  stroke-width: 1.2;
}

.gauge-needle {
  stroke: #111;
  stroke-width: 2.4;
}

.gauge-hub {
  fill: #111;
}

.gauge-percent {
  font-size: 14px;
  position: absolute;
  top: 44px;
  transform: translateY(-4px);
}

.gauge-text {
  white-space: nowrap;
}

.bar-wrap {
  width: 132px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bar-svg {
  width: 132px;
  height: 28px;
  overflow: visible;
}

.bar-needle {
  stroke: #111;
  stroke-width: 1.6;
}

.bar-hub {
  fill: #111;
}

.bar-percent {
  font-size: 11px;
  font-weight: 700;
  dominant-baseline: hanging;
}`, "",{"version":3,"sources":["webpack://./src/styles/RatingProgressBar.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;AACF;;AAEA;EACE,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,UAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AACF;;AAEA;EACE,UAAA;EACA,2BAAA;EACA,gBAAA;EACA,qBAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;AACF","sourcesContent":[".rating-gauge {\n  align-items: flex-end;\n  display: flex;\n  flex-direction: column;\n  font-size: 14px;\n}\n\n.gauge-wrap {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  width: 132px;\n}\n\n.gauge-svg {\n  height: 65px;\n  overflow: visible;\n}\n\n.gauge-track {\n  fill: none;\n  stroke: #e6e6e6;\n  stroke-width: 10;\n  stroke-linecap: round;\n}\n\n.gauge-sweep {\n  fill: none;\n  stroke: url(#gaugeGradient);\n  stroke-width: 10;\n  stroke-linecap: round;\n}\n\n.gauge-tick {\n  stroke: #d0d0d0;\n  stroke-width: 1.2;\n}\n\n.gauge-needle {\n  stroke: #111;\n  stroke-width: 2.4;\n}\n\n.gauge-hub {\n  fill: #111;\n}\n\n.gauge-percent {\n  font-size: 14px;\n  position: absolute;\n  top: 44px;\n  transform: translateY(-4px);\n}\n\n.gauge-text {\n  white-space: nowrap;\n}\n\n.bar-wrap {\n  width: 132px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.bar-svg {\n  width: 132px;\n  height: 28px;\n  overflow: visible;\n}\n\n.bar-needle {\n  stroke: #111;\n  stroke-width: 1.6;\n}\n\n.bar-hub {\n  fill: #111;\n}\n\n.bar-percent {\n  font-size: 11px;\n  font-weight: 700;\n  dominant-baseline: hanging;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
